{
  "familyId": "GELD-MAAK",
  "questions": [
    {
      "id": "GELD-MAAK-001",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €2,75 met munten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€2,75", "€2,70", "€2,80", "€3,00"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 275,
          "allowedDenoms": [
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"},
            {"valueCents": 5, "type": "coin", "label": "5 cent"}
          ],
          "constraints": {"maxTokens": 8}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 275, "breakdown": {"coins": [{"value": 200, "count": 1}, {"value": 50, "count": 1}, {"value": 20, "count": 1}, {"value": 5, "count": 1}]}, "showCoins": true, "label": "Zo maak je €2,75: €2 + 50 cent + 20 cent + 5 cent = €2,75"}, "a11y": {"alt": "Uitleg: €2 + 50 cent + 20 cent + 5 cent = €2,75"}}],
      "conceptId": "make_amount_coins",
      "variantIndex": 1,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Begin met de grootste munt die past en werk naar beneden. Pak eerst €2 (grootste munt ≤ €2,75). Je hebt nog 75 cent nodig: pak 50 cent, dan 20 cent, dan 5 cent. Tel op: €2 + 50 cent + 20 cent + 5 cent = €2,75.",
        "distractorExplanations": {
          "0": "Correct! €2 + 50 cent + 20 cent + 5 cent = €2,75.",
          "1": "De laatste kleine munt is vergeten. Je hebt €2,70 gemaakt, maar het moet €2,75 zijn. Je mist nog 5 cent — controleer altijd of je totaal klopt.",
          "2": "Er is een munt te veel gepakt. Je hebt €2,80 gemaakt, dat is 5 cent te veel. Tel altijd je munten na: het moet precies €2,75 zijn.",
          "3": "Hier is afgerond naar een rond bedrag. Je hebt €3,00 gemaakt, maar dat is 25 cent te veel. Het moet precies €2,75 zijn — niet afronden."
        }
      }
    },
    {
      "id": "GELD-MAAK-002",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €4,50 met munten en biljetten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€4,50", "€4,00", "€5,00", "€4,40"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 450,
          "allowedDenoms": [
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"}
          ],
          "constraints": {"maxTokens": 8}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 450, "breakdown": {"coins": [{"value": 200, "count": 2}, {"value": 50, "count": 1}]}, "showCoins": true, "label": "Zo maak je €4,50: 2×€2 + 1×50 cent = €4 + 50 cent = €4,50"}, "a11y": {"alt": "Uitleg: €2 + €2 + 50 cent = €4,50"}}],
      "conceptId": "make_amount_round",
      "variantIndex": 2,
      "citoDifficulty": 0.13,
      "citoDiscrimination": 0.80,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Begin met de grootste munt die past en werk naar beneden. Pak twee munten van €2 (samen €4). Je hebt nog 50 cent nodig: pak 1 munt van 50 cent. Tel op: €2 + €2 + 50 cent = €4,50.",
        "distractorExplanations": {
          "0": "Correct! €2 + €2 + 50 cent = €4,50.",
          "1": "De centen zijn vergeten. Je hebt €4,00 gemaakt, maar je mist nog 50 cent. Kijk altijd naar het bedrag achter de komma.",
          "2": "Er is een munt te veel gepakt. Je hebt €5,00 gemaakt, dat is 50 cent te veel. Het moet precies €4,50 zijn.",
          "3": "De verkeerde munt is gepakt voor de centen. Je hebt €4,40 gemaakt — je pakte 2×20 cent in plaats van 50 cent. Controleer je totaal."
        }
      }
    },
    {
      "id": "GELD-MAAK-003",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €6,35 met munten en biljetten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€6,35", "€6,53", "€5,35", "€7,35"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 635,
          "allowedDenoms": [
            {"valueCents": 500, "type": "bill", "label": "€5"},
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"},
            {"valueCents": 5, "type": "coin", "label": "5 cent"}
          ],
          "constraints": {"maxTokens": 10}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 635, "breakdown": {"bills": [{"value": 500, "count": 1}], "coins": [{"value": 100, "count": 1}, {"value": 20, "count": 1}, {"value": 10, "count": 1}, {"value": 5, "count": 1}]}, "showCoins": true, "showBills": true, "label": "Zo maak je €6,35: €5 + €1 + 20 cent + 10 cent + 5 cent = €6,35"}, "a11y": {"alt": "Uitleg: €5 biljet + €1 munt + 20 cent + 10 cent + 5 cent = €6,35"}}],
      "conceptId": "make_amount_bills",
      "variantIndex": 3,
      "citoDifficulty": 0.17,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Begin met het grootste biljet dat past en werk naar beneden. Pak een biljet van €5. Je hebt nog €1,35 nodig: pak €1, dan 20 cent, dan 10 cent, dan 5 cent. Tel op: €5 + €1 + 20 cent + 10 cent + 5 cent = €6,35.",
        "distractorExplanations": {
          "0": "Correct! €5 + €1 + 20 cent + 10 cent + 5 cent = €6,35.",
          "1": "De cijfers achter de komma zijn omgedraaid. Je hebt €6,53 gemaakt in plaats van €6,35. Let goed op de volgorde van de centen: 35 cent, niet 53 cent.",
          "2": "Een biljet of munt is vergeten. Je hebt €5,35 gemaakt — je mist nog €1. Begin met €5, dan heb je nog €1,35 nodig.",
          "3": "Er is een biljet of munt te veel gepakt. Je hebt €7,35 gemaakt, dat is €1 te veel. Controleer of je niet per ongeluk een extra €1-munt hebt gepakt."
        }
      }
    },
    {
      "id": "GELD-MAAK-004",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €8,20 met zo min mogelijk munten en biljetten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€8,20", "€8,00", "€8,30", "€8,10"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 820,
          "allowedDenoms": [
            {"valueCents": 500, "type": "bill", "label": "€5"},
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"}
          ],
          "constraints": {"preferMinimalTokens": true, "maxTokens": 8}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 820, "breakdown": {"bills": [{"value": 500, "count": 1}], "coins": [{"value": 200, "count": 1}, {"value": 100, "count": 1}, {"value": 20, "count": 1}]}, "showCoins": true, "showBills": true, "label": "De slimste manier: €5 + €2 + €1 + 20 cent = €8,20 met slechts 4 stuks"}, "a11y": {"alt": "Uitleg: €5 biljet + €2 munt + €1 munt + 20 cent = €8,20 met slechts 4 stuks"}}],
      "conceptId": "make_amount_minimal_bills",
      "variantIndex": 4,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Gebruik zo min mogelijk stuks door altijd de grootste munt of het grootste biljet te pakken dat past. Pak eerst het €5-biljet (1 stuk). Nog €3,20 over: pak €2 (1 stuk). Nog €1,20 over: pak €1 (1 stuk). Nog 20 cent over: pak 20 cent (1 stuk). Totaal: €5 + €2 + €1 + 20 cent = €8,20 met slechts 4 stuks.",
        "distractorExplanations": {
          "0": "Correct! €5 + €2 + €1 + 20 cent = €8,20 met slechts 4 stuks (minimaal).",
          "1": "De centen zijn vergeten. Je hebt €8,00 gemaakt, maar je mist nog 20 cent. Kijk altijd naar het bedrag achter de komma.",
          "2": "Een verkeerde munt is gepakt voor de centen. Je hebt €8,30 gemaakt, dat is 10 cent te veel. Gebruik 20 cent, niet 20 + 10 cent.",
          "3": "De verkeerde kleine munt is gepakt. Je hebt €8,10 gemaakt — je pakte 10 cent in plaats van 20 cent. Het moet €8,20 zijn."
        }
      }
    },
    {
      "id": "GELD-MAAK-005",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €3,85 met munten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€3,85", "€3,80", "€3,90", "€4,00"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 385,
          "allowedDenoms": [
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"},
            {"valueCents": 5, "type": "coin", "label": "5 cent"}
          ],
          "constraints": {"maxTokens": 10}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 385, "breakdown": {"coins": [{"value": 200, "count": 1}, {"value": 100, "count": 1}, {"value": 50, "count": 1}, {"value": 20, "count": 1}, {"value": 10, "count": 1}, {"value": 5, "count": 1}]}, "showCoins": true, "label": "Zo maak je €3,85: €2 + €1 + 50 cent + 20 cent + 10 cent + 5 cent = €3,85"}, "a11y": {"alt": "Uitleg: €2 + €1 + 50 cent + 20 cent + 10 cent + 5 cent = €3,85"}}],
      "conceptId": "make_amount_complex",
      "variantIndex": 5,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Begin met de grootste munt die past en werk naar beneden. Pak eerst €2 (grootste munt ≤ €3,85). Pak dan €1 (samen €3). Je hebt nog 85 cent nodig: 50 cent + 20 cent + 10 cent + 5 cent = 85 cent. Tel op: €3 + 85 cent = €3,85.",
        "distractorExplanations": {
          "0": "Correct! €2 + €1 + 50 cent + 20 cent + 10 cent + 5 cent = €3,85.",
          "1": "De laatste kleine munt is vergeten. Je hebt €3,80 gemaakt, maar je mist nog 5 cent. Tel altijd alle munten na.",
          "2": "Er is een munt te veel gepakt. Je hebt €3,90 gemaakt, dat is 5 cent te veel. Controleer of je niet per ongeluk een extra 5-cent munt hebt gepakt.",
          "3": "Hier is afgerond naar een rond bedrag. Je hebt €4,00 gemaakt, maar dat is 15 cent te veel. Het moet precies €3,85 zijn — niet afronden."
        }
      }
    },
    {
      "id": "GELD-MAAK-006",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €7,60 met munten en biljetten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€7,60", "€7,50", "€7,70", "€8,00"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 760,
          "allowedDenoms": [
            {"valueCents": 500, "type": "bill", "label": "€5"},
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"}
          ],
          "constraints": {"maxTokens": 10}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 760, "breakdown": {"bills": [{"value": 500, "count": 1}], "coins": [{"value": 200, "count": 1}, {"value": 50, "count": 1}, {"value": 10, "count": 1}]}, "showCoins": true, "showBills": true, "label": "Zo maak je €7,60: €5 + €2 + 50 cent + 10 cent = €7,60"}, "a11y": {"alt": "Uitleg: €5 biljet + €2 munt + 50 cent + 10 cent = €7,60"}}],
      "conceptId": "make_amount_large",
      "variantIndex": 6,
      "citoDifficulty": 0.16,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Begin met het grootste biljet en werk naar beneden. Pak het €5-biljet. Pak dan de €2-munt (samen €7). Je hebt nog 60 cent nodig: 50 cent + 10 cent = 60 cent. Tel op: €5 + €2 + 50 cent + 10 cent = €7,60.",
        "distractorExplanations": {
          "0": "Correct! €5 + €2 + 50 cent + 10 cent = €7,60.",
          "1": "Een kleine munt is vergeten. Je hebt €7,50 gemaakt, maar je mist nog 10 cent. Na 50 cent heb je nog 10 cent nodig om op 60 cent te komen.",
          "2": "Er is een munt te veel gepakt. Je hebt €7,70 gemaakt, dat is 10 cent te veel. Controleer: 50 cent + 10 cent = 60 cent, niet 70 cent.",
          "3": "Hier is afgerond naar een rond bedrag. Je hebt €8,00 gemaakt, maar dat is 40 cent te veel. Het moet precies €7,60 zijn."
        }
      }
    },
    {
      "id": "GELD-MAAK-007",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "matching",
      "question": "Koppel de bedragen aan de juiste munten/biljetten combinatie.",
      "options": ["Match 1", "Match 2", "Match 3", "Match 4"],
      "correctAnswer": 0,
      "data": {
        "matching": {
          "pairs": [
            {"left": "€2,50", "right": "2×€1 + 1×50ct"},
            {"left": "€1,75", "right": "1×€1 + 1×50ct + 1×20ct + 1×5ct"},
            {"left": "€3,00", "right": "3×€1"},
            {"left": "€5,50", "right": "1×€5 + 1×50ct"}
          ]
        }
      },
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 250, "showCoins": true, "showBills": false, "breakdown": {"coins": [{"value": 100, "count": 2}, {"value": 50, "count": 1}], "bills": []}, "label": "Voorbeeld: €2,50 = 2×€1 + 1×50 cent. Tel de munten bij elkaar op."}}],
      "conceptId": "money_composition_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.14,
      "citoDiscrimination": 0.79,
      "stimulusAids": [],
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Tel bij elk bedrag de munten stap voor stap op. €2,50 = 2×€1 + 50 cent. €1,75 = €1 + 50 cent + 20 cent + 5 cent. €3,00 = 3×€1. €5,50 = €5 + 50 cent.",
        "distractorExplanations": {
          "0": "Correct! Je hebt alle bedragen goed gekoppeld aan de juiste munten.",
          "1": "De munten zijn niet goed opgeteld. Tel elke combinatie apart op en controleer of het totaal klopt met het bedrag links.",
          "2": "De waarde van munten is verwisseld. Controleer: €1 = 100 cent, 50 cent = een halve euro. Tel de munten stap voor stap op.",
          "3": "Euro's en centen zijn door elkaar gehaald. Let op de komma: het bedrag links geeft precies aan hoeveel euro en cent je nodig hebt."
        }
      }
    }
  ]
}